module.exports = __webpack_public_path__ + "img/ajeeyoo.f6aff9d2.png";